import React, { Component } from "react";
import { connect } from "react-redux";
import Style from "style-it";
import PaymentFilter from "../../../Components/common/PaymentFilter";

class PaymentsSidebar extends Component {
  render() {
    return (
      <Style>
        {`.material-icons {vertical-align: middle; color: inherit}`}
        <div className="fms-sidebar sidebar-bg-layer">
          <h3
            style={{
              display: "flex",
              alignItems: "center",
              margin: 10,
              marginLeft: 10,
              marginTop: 14,
              marginBottom: 0,
              fontSize: 21,
            }}
            className="alt-title sidebar-icon-gap"
          >
            {this.props.translate("payments")}
          </h3>
          <PaymentFilter
            {...this.props}
            formSubmit={this.props.submitSideBarSearch}
            downloadInvoice={this.props.downloadInvoice}
            sidebar
            loader={this.props.loader}
          />
        </div>
      </Style>
    );
  }
}

const mapState = (state) => ({
  themecolors: state.themeColors,
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
});

export default connect(mapState)(PaymentsSidebar);
